/* eslint-disable no-multi-assign */
/* eslint-disable no-param-reassign */
import React from 'react';
import { defaultRanges } from '../defaults';
import moment from 'moment';
import Menu from './Menu';
import { getValidatedMonths, parseOptionalDate } from '../utils';
export const MARKERS = {
    FIRST_MONTH: Symbol('firstMonth'),
    SECOND_MONTH: Symbol('secondMonth')
};
const DateRangePicker = (props) => {
    const today = new Date();
    const { open, onChange, initialDateRange, minDate, maxDate, definedRanges = defaultRanges } = props;
    const minDateValid = parseOptionalDate(minDate, moment(today).add(-10, 'years').toDate());
    const maxDateValid = parseOptionalDate(maxDate, moment(today).add(10, 'years').toDate());
    const [intialFirstMonth, initialSecondMonth] = getValidatedMonths(initialDateRange || {}, minDateValid, maxDateValid);
    const [dateRange, setDateRange] = React.useState({ ...initialDateRange });
    const [hoverDay, setHoverDay] = React.useState();
    const [firstMonth, setFirstMonth] = React.useState(intialFirstMonth || today);
    const [secondMonth, setSecondMonth] = React.useState(initialSecondMonth || moment(firstMonth).add(1, 'month').toDate());
    const { startDate, endDate } = dateRange;
    // handlers
    const setFirstMonthValidated = (date) => {
        if (moment(date).isBefore(secondMonth)) {
            setFirstMonth(date);
        }
    };
    const setSecondMonthValidated = (date) => {
        if (moment(date).isAfter(firstMonth)) {
            setSecondMonth(date);
        }
    };
    const setDateRangeValidated = (range) => {
        let { startDate: newStart, endDate: newEnd } = range;
        if (newStart && newEnd) {
            range.startDate = newStart = moment.max([moment(newStart), moment(minDateValid)]).toDate();
            range.endDate = newEnd = moment.min([moment(newEnd), moment(maxDateValid)]).toDate();
            setDateRange(range);
            onChange(range);
            setFirstMonth(newStart);
            setSecondMonth(moment(newStart).isSame(newEnd, 'month') ? moment(newStart).add(1, 'month').toDate() : newEnd);
        }
        else {
            const emptyRange = {};
            setDateRange(emptyRange);
            onChange(emptyRange);
            setFirstMonth(today);
            setSecondMonth(moment(firstMonth).add(1, 'month').toDate());
        }
    };
    const onDayClick = (day) => {
        if (startDate && !endDate && !moment(day).isBefore(startDate)) {
            const newRange = { startDate, endDate: day };
            onChange(newRange);
            setDateRange(newRange);
        }
        else {
            setDateRange({ startDate: day, endDate: undefined });
        }
        setHoverDay(day);
    };
    const onMonthNavigate = (marker, action) => {
        if (marker === MARKERS.FIRST_MONTH) {
            const firstNew = moment(firstMonth).add(action, 'month').toDate();
            if (moment(firstNew).isBefore(secondMonth))
                setFirstMonth(firstNew);
        }
        else {
            const secondNew = moment(secondMonth).add(action, 'month').toDate();
            if (moment(firstMonth).isBefore(secondMonth))
                setSecondMonth(secondNew);
        }
    };
    const onDayHover = (date) => {
        if (startDate && !endDate) {
            if (!hoverDay || !moment(date).isSame(hoverDay, 'day')) {
                setHoverDay(date);
            }
        }
    };
    // helpers
    const inHoverRange = (day) => (startDate && !endDate && hoverDay && moment(hoverDay).isAfter(startDate) && moment(day).isBetween(startDate, hoverDay, undefined, '[]'));
    const helpers = {
        inHoverRange
    };
    const handlers = {
        onDayClick,
        onDayHover,
        onMonthNavigate
    };
    return open ? (<Menu dateRange={dateRange} minDate={minDateValid} maxDate={maxDateValid} ranges={definedRanges} firstMonth={firstMonth} secondMonth={secondMonth} setFirstMonth={setFirstMonthValidated} setSecondMonth={setSecondMonthValidated} setDateRange={setDateRangeValidated} helpers={helpers} handlers={handlers}/>) : null;
};
export default DateRangePicker;
